var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconPersonalData = function SvgIconPersonalData(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFE9A8"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11 11a4.583 4.583 0 1 0 0-9.167A4.583 4.583 0 0 0 11 11M2.292 20.167c0-1.945.917-3.81 2.55-5.186S8.69 12.833 11 12.833s4.525.773 6.158 2.148 2.55 3.24 2.55 5.186z"
  }))));
};
export default SvgIconPersonalData;